<template>
  <div id="app">
    <myheader></myheader>
    <div class="header-bj w-100 h-100 wow bounceInUp pc">
      <img class="w-100 h-100" src="../img/product/header_bj.png" alt />
    </div>
    <div class="mb">
        <img class="w-100 mb" src="../../static/img/product/mb_product_banner.png" alt />
    </div>
    <div class="Breadcrumb">
      <el-breadcrumb class="Breadcrumb_item" separator-class="el-icon-arrow-right">
        <span>
          <i class="el-icon-minus"></i> Posición actual：
        </span>
        <el-breadcrumb-item :to="{ path: '/ESP' }">HOME</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/product_item_ESP',query:{id:51} }">PRODUCTOS</el-breadcrumb-item>
        <el-breadcrumb-item>{{product.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main">
      <div class="main_1 row">
        <div class="main1_img col-lg-6 col-md-12 col-sm-12 row">
          <div class="main_img_left col-lg-9 col-md-12">
            <img
              v-if="product_images[bigtu]!==undefined"
              class="w-100"
              :src="`http://www.waternaida.com/${product_images[bigtu]}`"
            />
          </div>
          <div class="main_img_right col-lg-3 col-md-12 float-sm-left">
            <div class="main_img_right_1" v-for="(item,index) in product_images" :key="index">
              <img class="w-100" :src="`http://www.waternaida.com/${item}`" @click="tu(index)" />
            </div>
          </div>
        </div>
        <div class="main1_txt col-lg-6 col-md-12 col-sm-12">
          <span class="main1_txt_title">{{product.name}}</span>
          <span class="main1_txt_product w-100" v-html="product.content"></span>
          <div class="main1_txt_img w-100">
            <img
              v-for="(item,index) in product_logo.length"
              :key="index"
              :src="`http://www.waternaida.com${product_logo[index]}`"
              alt
            />
          </div>
        </div>
      </div>
      <img class="w-100" src="../img/product/main_bj.png" alt />
      <div class="main_2 row">
        <div class="main_2_header col-12">
          <span class="main_2_header_txt">Recommended Products</span>
          <el-divider class="main_header_xian"></el-divider>
        </div>
        <!-- 电脑端 -->
        <div class="product_item row pc">
          <div class="product_item1 col-lg-3 col-md-3 col-sm-3 w-100" v-for="(item,index) in prohot.proList" :key="index">
            <div class="product_item1_1">
                <router-link :to="{path:'/product_item_ESP',query:{id:item.id}}" @click.native="updateData()" target="_blank">
                    <img class="product_item1_img w-100" :src="`http://www.waternaida.com/${item.image}`" alt />
                    <span class="product_item1_txt">{{item.name}}</span>
                </router-link>
            </div>
          </div>
        </div>
        <!-- 手机端 -->
        <div class="product_item row mb">
          <div class="product_item1 col-lg-3 col-md-3 col-sm-3 w-100" v-for="(item,index) in prohot.proList" :key="index">
            <div class="product_item1_1">
                <router-link :to="{path:'/product_item_ESP',query:{id:item.id}}" @click.native="updateData()">
                    <img class="product_item1_img w-100" :src="`http://www.waternaida.com/${item.image}`" alt />
                    <span class="product_item1_txt">{{item.name}}</span>
                </router-link>
            </div>
          </div>
        </div>

      </div>
      <div class="main_3 row">
        <div class="main_2_header col-12">
          <span class="main_2_header_txt">Email us for a quote</span>
          <el-divider class="main_header_xian"></el-divider>
        </div>
        <div class="main_3_input w-100 row">
          <el-input
            class="input_name col-lg-4 col-md-12 col-sm-12 w-100"
            placeholder="Nombre"
            v-model="input_name"
          ></el-input>
          <el-input
            class="input_number col-lg-4 col-md-12 col-sm-12"
            placeholder="Teléfono"
            v-model="input_number"
          ></el-input>
          <el-input
            class="input_email col-lg-4 col-md-12 col-sm-12"
            placeholder="E-mail"
            v-model="input_email"
          ></el-input>
          <div class="Content col-lg-12 w-100">
            <el-input type="textarea" :rows="11" v-model="input_contact" placeholder="Por favor ingrese el contenido"></el-input>
          </div>
          <div class="main_btn w-100 row">
            <el-button class="main_btn_txt col-lg-2 col-md-6 col-sm-12 w-100" type="primary">Enviar</el-button>
            <el-button class="main_btn_txt col-lg-2 col-md-6 col-sm-12 w-100">Reiniciar</el-button>
          </div>
        </div>
      </div>
      <img class="w-100 h-100 main_bj2" src="../img/product/main_bj_1.png" alt />
    </div>
    <myfooter></myfooter>
  </div>
</template>
<style scoped>
#app {
  width: 100%;
}
.row {
  margin: 0;
  padding: 0;
}
.main_3_input >>> .el-input__inner {
  background-color: #e5e5e5;
}
.main_3_input >>> .el-textarea__inner {
  background-color: #e5e5e5;
}
.main_3_input {
  margin-top: 50px;
}
.header-bj {
  margin-top: 40px;
}
.main_bj2 {
  margin-top: -110px;
  margin-bottom: -70px;
}
.Content {
  margin-top: 20px;
}
.main_btn_txt {
  font-size: 1.25rem;
}
.main_btn {
  width: 100%;
  padding-right: 15px;
  margin-top: 20px;
  /* background-color: lightsalmon; */
  height: 80px;
  display: block;
  text-align: right;
}
/* .Content>>> .el-input__inner{
    height: 300px;
 } */
.product_item1_1 {
  width: 100%;
  height: 100%;
  /* background-color: lightpink; */
  /* border:1px solid rgb(0, 0, 0); */
  box-shadow: 0px 1px 5px #888888;
  padding-bottom: 20px;
}
.product_item {
  display: flex;
  width: 100%;
  margin-top: 50px;
}
.product_item1 {
  /* background-color: lightgrey; */
  /* margin-left: 10px; */
  width: 25%;
}
.product_item1_img {
  display: block;
  margin: 0 auto;
  width: 70%;
}
.product_item1_txt {
  display: block;
  width: 100%;
  height: 100%;
}
.main_header_xian {
  width: 75%;
  /* background-color: lightcyan; */
}
.main_2_header_txt {
  width: 25%;
  /* background-color: lightgreen; */
  font-size: 1.25rem;
  color: #0092d6;
}
.main_2_header {
  float: left;
  width: 100%;
  text-align: left;
  display: flex;
}
.main_3 {
  width: 80%;
  margin: 0 auto;
  margin-top: 50px;
}
.main_2 {
  width: 80%;
  margin: 0 auto;
  margin-top: 50px;
}
.el-icon-minus {
  color: #409eff;
  width: 30px;
}
.Breadcrumb {
  /* background: lightblue; */
  display: block;
  width: 80%;
  margin: 0 auto;
  /* float: right; */
  margin-bottom: 100px;
}
.Breadcrumb_item > span {
  float: left;
  display: block;
}
.Breadcrumb_item {
  float: right;
  /* background-color: lightcoral; */
}
.main_txt {
  display: flex;
}
.main1_txt_img {
  display: block;
  text-align: left;
  margin-left: -30px;
  margin-top: 30px;
  width: 100%;
  display: none;
}
.main1_txt_img > img {
  width: 20%;
}
.main1_txt_title {
  font-size: 2rem;
  color: #024d83;
  text-align: left;
  display: block;
}
.main1_txt_product {
  text-align: left;
  display: block;
  color: rgb(172, 172, 172);
  margin-top: 25px;
  line-height: 30px;
  font-size: 1rem;
  word-wrap: break-word;
  /* word-break: break-all; */
  overflow: hidden;
}
.main1_txt_product a{
    color: inherit!important;
}
.main_1 {
  width: 98%;
  margin: 0 auto;
}
.main1_img {
  float: left;
  display: flex;
}
.main_img_right {
  margin-left: -13px;
  margin-top: -2px;
}
.main_img_left img {
  box-shadow: 0px 1px 5px #888888;
}
.main_img_right_1 img {
  box-shadow: 0px 1px 5px #888888;
  margin-bottom: 3%;
}
.product_item.mb{
    display: none;
}
@media screen and (max-width: 1200px) {
  .header-bj{
   margin-top: 0px;
  }
}
@media screen and (max-width: 992px) {
    .product_item.pc{
        display: none;
    }
    .product_item.mb{
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
    }
  .main_img_right_1 {
    width: 25%;
    float: left;
    padding: 1%;
    margin-top: 5%;
  }
  .main_img_right {
    margin: 0;
  }
  .main_img_left > img {
    width: 600px !important;
  }
  .input_name {
    margin-bottom: 2%;
  }
  .input_number {
    margin-bottom: 2%;
  }
  .main_btn {
    float: left;
    padding: 0;
  }
  .el-button + .el-button {
    margin-left: 0px !important;
    margin-top: 3%;
  }
  .main_2_header_txt {
    width: 100%;
    /* background-color: lightgreen; */
    font-size: 1.25rem;
    color: #0092d6;
    line-height: 49px;
  }
  .Breadcrumb{
    float: left;
  }
  .Breadcrumb_item{
    float: left;
  }
}
@media screen and (max-width: 576px) {
  .main_img_right_1 {
    width: 25%;
    float: left;
    padding: 1%;
    margin-top: 5%;
  }
  .main_img_right {
    margin: 0;
  }
  .main_img_left > img {
    width: 250px !important;
  }
  .main_2 {
    width: 98%;
  }
  .product_item1 {
    width: 50% !important;
    margin-bottom: 5%;
  }
  .el-button + .el-button {
    margin-left: 0px !important;
  }
  .main_2_header_txt {
    font-size: 16px;
  }
  .main_3 {
    width: 98%;
  }
}
</style>
<script>
import myfooter from "./zzj/footer_ESP";
import myheader from "./zzj/header_ESP";
import WOW from "wowjs";
export default {
  data() {
    return {
      input_name: "",
      input_number: "",
      input_email: "",
      input_contact: "",
      bigtu: 0,
      product: [],
      prohot: [],
      product_logo: [],
      product_images: []
    };
  },
  components: {
    myfooter: myfooter,
    myheader: myheader
  },
  methods: {
    tu(index) {
      this.bigtu = index;
      console.log(this.bigtu);
    },
    reset() {
      this.input_name = "";
      this.input_number = "";
      this.input_email = "";
      this.input_contact = "";
    },
    tijiao() {
      let name = this.input_name;
      let phone = input_number;
      let email = this.input_email;
      let contact = this.input_contact;
      let res_phone = /^1[345789]\d{9}$/;
      let res_email = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (name == "" || phone == "" || email == "" || contact == "") {
        alert("¡Por favor, introduzca el formato correcto!");
      } else if (res_phone.test(this.input_number) == false) {
        alert("¡Por favor, introduzca el número de teléfono correcto!");
      }else if(res_email.test(this.input_email) == false){
        alert("¡Por favor, introduzca el mensaje correcto!");
      } else {
        this.axios
          .post("/api/message/index", {
            name: this.input_name,
            phone: this.input_number,
            email: this.input_email,
            content: this.input_contact,
            language: "1"
          })
          .then(res => {
            alert("成功！");
          })
          .catch(err => {
            console.log(err);
          });
        this.reset();
      }
    },
    // 路由跳转刷新页面
    updateData () {
      this.$router.go(0)
    }
  },
  created() {
    let newId = this.$route.query.id;
    console.log(newId);
    let pp = this.$route.query.id;
    console.log(pp);
    const url = `/api/product/detail?proID=${newId}&language=2`;
    this.axios
      .get(url)
      .then(res => {
        this.product = res.data.proInfo;
        console.log(this.product);
        this.product_logo = this.product.s_images.split(",");
        this.product_images = this.product.images.split(",");
        console.log(this.product_logo);
        console.log(this.product_images);
      })
      .catch(err => {
        console.log(err);
      });

      this.axios
      .get("/api/product/index?langName=2")
      .then(res => {
        this.prohot = res.data;
        console.log(this.prohot);
      })
      .catch(err => {
        console.log(err);
      });

  },
  mounted() {
    let wow = new WOW.WOW({
      boxClass: "wow",
      animateClass: "animated",
      mobile: true,
      live: true
    });
    wow.init();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/product_item_ESP.vue